// Air temp
export enum AIR_TEMPERATURE_CATEGORY {
  extremelyCold = 'extremelyCold',
  cold = 'cold',
  moderate = 'moderate',
  warm = 'warm',
  hot = 'hot',
  extremelyHot = 'extremelyHot',
}

// Track temp
export enum TRACK_TEMPERATURE_CATEGORY {
  extremelyCold = 'extremelyCold',
  cold = 'cold',
  moderate = 'moderate',
  warm = 'warm',
  hot = 'hot',
  extremelyHot = 'extremelyHot',
}

// Wind
export enum WIND_CATEGORIES {
  calm = 'calm',
  breezy = 'breezy',
  windy = 'windy',
  blustery = 'blustery',
  gale = 'gale',
  storm = 'storm',
}

// Rain
export enum WEATHER_CATEGORIES {
  dry = 'dry',
  soft = 'soft',
  light = 'light',
  moderate = 'moderate',
  heavy = 'heavy',
  'very-heavy' = 'very-heavy',
}

// Bumps
export enum ROUGHNESS_CATEGORIES {
  'very-smooth' = 'very-smooth',
  smooth = 'smooth',
  average = 'average',
  bumpy = 'bumpy',
  'very-bumpy' = 'very-bumpy',
  'severe-bumps' = 'severe-bumps',
}

// Grid
export enum TARMAC_CONDITION_CATEGORIES {
  dirty = 'dirty',
  poor = 'poor',
  'below-average' = 'below-average',
  washed = 'washed',
  good = 'good',
  perfect = 'perfect',
}
